import type { NoteCardViewModel, NoteColor, StudentNote } from "../types"
import { formatNoteDate } from "./formatNoteDate"

const COLORS: NoteColor[] = ["blue", "emerald", "amber", "rose", "purple"]

const asColor = (value: string | undefined): NoteColor =>
  COLORS.includes(value as NoteColor) ? (value as NoteColor) : "blue"

export const mapNoteCard = (note: StudentNote): NoteCardViewModel => ({
  id: note.id,
  title: note.title,
  content: note.content,
  subject: note.subject || "General",
  color: asColor(note.color),
  dateLabel: formatNoteDate(note.created_at),
})
